import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { Card, Stack, Link, Container, Typography, Grid, Box } from '@mui/material';
// layouts
import AuthLayout from '../layouts/AuthLayout';
// components
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import { LoginForm } from '../components/authentication/login';
import AuthSocial from '../components/authentication/AuthSocial';
import Layout from '../layouts/LayoutFirst/Layout';
// ----------------------------------------------------------------------
const useStyles = makeStyles((theme) => ({
  wraper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '140px',
    minHeight: '500px',
    backgroundColor: 'white'
  },
  gridContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'white'
  },
  item: {
    backgroundColor: 'white'
  },
  imgContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    backgroundColor: 'white'
  },
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'contain'
  }
}));

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 500,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  borderRadius: 0,
  marginRight: 10
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  const classes = useStyles();
  return (
    <Grid className={classes.wraper}>
      <Container>
        <Grid container xs={12} className={classes.gridContainer}>
          <MHidden width="mdDown">
            <Grid item md={5} xs="none" className={classes.item}>
              <Box className={classes.imgContainer}>
                <img src="/static/login/login.png" className={classes.img} alt="login" />
              </Box>
            </Grid>
          </MHidden>
          <Grid item xs={12} md={5} className={classes.item}>
            <LoginForm />
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
}
